import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  __async
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/accessibility/getAccessibilityRequests.ts
import { Exception } from "@wbk/logger";
import { getLocaleOnly } from "@wbk/utils";
var getAccessibilityRequests = (_0) => __async(null, [_0], function* ({ lang }) {
  try {
    const locale = getLocaleOnly(lang);
    const data = yield fetchClient({
      url: `/accessibility-profile?lang=${locale}`
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getAccessibilityRequestsException"
    });
  }
});

export {
  getAccessibilityRequests
};
//# sourceMappingURL=chunk-G6JPNACT.mjs.map